var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.874V2.124c0-.497.198-.974.55-1.325l.137-.125A1.875 1.875 0 0 1 3.375.25H11.5c.166 0 .325.065.442.183l4.375 4.375a.625.625 0 0 1 .183.442v10.625a1.875 1.875 0 0 1-1.875 1.875H3.375c-.435 0-.855-.152-1.188-.425l-.138-.125a1.875 1.875 0 0 1-.549-1.325Zm5.55-8.1a.625.625 0 0 1 .883.884l-1.57 1.569 1.57 1.57.043.048a.624.624 0 0 1-.879.878l-.048-.043-2.01-2.01a.625.625 0 0 1 0-.884l2.01-2.012Zm3.017 0a.625.625 0 0 1 .836-.043l.048.043 2.01 2.012a.625.625 0 0 1 0 .883l-2.01 2.011a.625.625 0 1 1-.884-.883l1.569-1.57-1.57-1.57-.042-.046a.625.625 0 0 1 .043-.837Zm-7.317 8.1c0 .166.066.325.183.442l.095.079a.625.625 0 0 0 .347.105h11.25a.625.625 0 0 0 .625-.626V5.508L11.241 1.5H3.375a.625.625 0 0 0-.347.104l-.095.079a.625.625 0 0 0-.183.442v13.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h17.5v17.5H.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCode);
export default __webpack_public_path__ + "static/media/file-code.de67601e3face1743626a3f1c895298b.svg";
export { ForwardRef as ReactComponent };